export const STATE = {
  SELECTION_CHANGE: 'change:selection',
  CONDITION_CHANGE: 'change:condition',
  EXTENT_CHANGE: 'change:extent'
};

export const VIEW = {
  TOGGLE_TABLE_VISIBILITY: 'view:toggle-table-visibility',
  TOGGLE_TABLE_OVERLAY: 'view:toggle-table-overlay',
  LAYOUT_CHANGED: 'view:layoutChanged'
};

export const MAP = {
  SELECTOR_LAYER_SELECTION_CHANGED: 'map:selectorLayerSelectionChanged',
  FILTER_CONDITION_CHANGED: 'map:filterConditionChanged'
};

export const TABLE = {
  ROW_SELECTION_CHANGED: 'table:rowSelectionChanged'
};
